module.exports = __webpack_public_path__ + "img/swingcycle1.82fd4eb4.svg";